import { z } from 'zod';

export const cropFileInfoSchema = z.object({
  filename: z.string(),
  path: z.string(),
  sizeBytes: z.number(),
  createdAtMs: z.number(),
  subfolder: z.string().nullable(),
  startMs: z.number().nullable().optional(),
  endMs: z.number().nullable().optional(),
  durationMs: z.number().nullable().optional(),
});

export type ICropFileInfo = z.infer<typeof cropFileInfoSchema>;

export const listCropsResponseSchema = z.object({
  files: z.array(cropFileInfoSchema),
});

export type IListCropsResponse = z.infer<typeof listCropsResponseSchema>;
